import request from "@/utils/request.js";

// 拿微信授权码(code)换openId，这个接口长在 provider-activity 服务上，
// 是从 jkhh_hsj_appweb 项目里确认过的现成接口，直接复用，不用自己对接微信官方接口。
export function getOpenIdByCode(params) {
  return request({
    url: "/activityService/api/app/common/ext/getOpenIdByCode",
    method: "post",
    data: params,
  });
}

// "注册"一个跳回地址，换一个短state。因为公众号后台"网页授权域名"那两个位置已经被占满，
// 塞不进咱们自己的域名，只能借用 wxauth.hulian120.com 这个中转服务(它在白名单里)当redirect_uri，
// 它靠这个state找到原始地址，把用户带回来。
// 注意：这是跨域调用wxauth.hulian120.com这个独立服务，不走咱们自己的网关，但axios支持直接传完整地址，
// 会自动绕开baseURL，不用额外处理。
export function registerShortUrl(url) {
  return request({
    url: "https://wxauth.hulian120.com/short/url?isshortSence=true",
    method: "post",
    data: { url },
  });
}
